/** @jsx jsx */
import React, { type ReactNode } from 'react';

import { cssMap, jsx } from '@atlaskit/css';
import { targetTranslation } from './translations/targetTranslation.tsx';

const styles = cssMap({
	root: {
		width: 'fit-content',
	},
	fullWidth: {
		width: '100%',
	},
});

export interface SpotlightTargetProps {
	/**
	 * A single child.
	 */
	children: ReactNode;
	/**
	 * The name to reference from Spotlight.
	 */
	name: string;
	/**
	 * Stretch to fill the full width of a parent container.
	 */
	isFullWidth?: boolean;
}

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */
const SpotlightTarget: {
	({ children, name, isFullWidth }: SpotlightTargetProps): React.JSX.Element;
	displayName: string;
} = ({ children, name, isFullWidth = false }: SpotlightTargetProps): React.JSX.Element => {
	const id = targetTranslation(name);

	return (
		<div css={[styles.root, isFullWidth && styles.fullWidth]} id={id}>
			{children}
		</div>
	);
};

SpotlightTarget.displayName = 'SpotlightTarget';

export { SpotlightTarget };
